import { Injectable } from '@angular/core';
import { IonContent, Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class scrollEventsService {
  constructor(private platform: Platform) {}

  currentScrollPosition = 0;
  headerVisible;

  scrollTop(content) {
    if (content === undefined) {
      return;
    }
    content.scrollToTop(0.5);
  }

  scrollDown(content: IonContent) {
    if (content === undefined) {
      return;
    }
    content.scrollToPoint(0, 300, 200);
    this.currentScrollPosition = 300;
  }

  scrollHeader(event, content) {
    if (this.platform.is('android')) {
      return;
    }

    const afterScrollPosition = event.detail.scrollTop;
    this.headerVisible = this.currentScrollPosition > 300 && afterScrollPosition > this.currentScrollPosition;
    this.currentScrollPosition = afterScrollPosition;
  }
}
